import reducer from "./reducer";
export { default as AnnotationsAnalysis } from "./components/index";
export { default as annotationsAnalysisReducerName } from "./constants";
export default reducer;
